function InstagramIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className} aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4.2" />
      <circle cx="17.2" cy="6.8" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

function TikTokIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
    </svg>
  );
}

export function SoundCloudIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M1.2 13.9c-.1 0-.2.1-.2.2l-.25 1.6c0 .1.08.2.2.2.11 0 .19-.09.2-.2l.25-1.6c0-.11-.09-.2-.2-.2zm1.6-.9c-.11 0-.2.09-.22.2l-.36 2.4c0 .11.09.2.2.2.12 0 .21-.09.23-.2l.36-2.4c.01-.11-.09-.2-.21-.2zm1.72-.7c-.12 0-.22.1-.22.22l-.33 3c0 .12.09.22.21.22.12 0 .22-.1.23-.22l.33-3c0-.12-.1-.22-.22-.22zm1.79-.5c-.12 0-.23.1-.23.23l-.3 3.44c0 .13.1.23.23.23.12 0 .23-.1.23-.23l.3-3.44c0-.13-.11-.23-.23-.23zm1.8-.3c-.13 0-.24.1-.24.24l-.25 3.68c0 .13.11.24.24.24.13 0 .24-.11.24-.24l.25-3.68c0-.14-.11-.24-.24-.24zm1.83-.1c-.14 0-.25.11-.25.25l-.2 3.8c0 .14.11.25.25.25.14 0 .25-.11.25-.25l.2-3.8c0-.14-.11-.25-.25-.25zm5.06-.75c-.3 0-.6.06-.86.16-.4-2.03-2.1-3.56-4.15-3.56-.51 0-1 .1-1.44.28-.17.07-.22.13-.22.29v8.32c0 .16.13.29.29.29h6.38c1.32 0 2.39-1.07 2.39-2.39s-1.07-2.39-2.39-2.39z" />
    </svg>
  );
}

export function SpotifyIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
    </svg>
  );
}

function YouTubeIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4L15.8 12l-6.2 3.6z" />
    </svg>
  );
}

const META = [
  { key: "instagram", label: "INSTAGRAM", Icon: InstagramIcon },
  { key: "tiktok", label: "TIKTOK", Icon: TikTokIcon },
  { key: "soundcloud", label: "SOUNDCLOUD", Icon: SoundCloudIcon },
  { key: "spotify", label: "SPOTIFY", Icon: SpotifyIcon },
  { key: "youtube", label: "YOUTUBE", Icon: YouTubeIcon },
];

export function SocialLinks({ socials, className = "gap-4", iconClass = "h-4 w-4", vertical = false, showLabels = false }) {
  const items = META.filter((m) => socials?.[m.key]);
  if (!items.length) return null;
  return (
    <div
      data-testid="social-links"
      className={`flex ${vertical ? "flex-col items-start" : "items-center"} ${className}`}
    >
      {items.map(({ key, label, Icon }) => (
        <a
          key={key}
          data-testid={`social-${key}`}
          href={socials[key]}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          className="inline-flex items-center gap-3 text-white/60 hover:text-white transition-colors"
        >
          <Icon className={iconClass} />
          {showLabels && <span className="text-[11px] tracking-[0.25em]">{label}</span>}
        </a>
      ))}
    </div>
  );
}

export default SocialLinks;
